export enum CommunicationPlatform {
  EMPLOYEE_WEB = "EMPLOYEE_WEB",
  EMPLOYER_WEB = "EMPLOYER_WEB",
  EMPLOYEE_PUSH_NOTIFICATION = "EMPLOYEE_PUSH_NOTIFICATION",
  EMPLOYEE_EMAIL = "EMPLOYEE_EMAIL"
}
